import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Credibility from "@/components/site/Credibility";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import CTABanner from "@/components/site/CTABanner";
import AuditForm from "@/components/site/AuditForm";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-[#050505] text-[#F5F5F5] overflow-x-hidden">
      <Header />
      <Hero />
      <Credibility />
      <Services />
      <Process />
      <About />
      <CTABanner />
      <AuditForm />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
}
